"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var jsx_runtime_1 = require("react/jsx-runtime");
var material_1 = require("@mui/material");
var styles_1 = require("@mui/material/styles");
var Tool_1 = __importDefault(require("./Tool"));
var PREFIX = 'ToolRow';
var classes = {
    toolWrapper: "".concat(PREFIX, "-toolWrapper"),
};
var StyledBox = (0, styles_1.styled)(material_1.Box)(function (_a) {
    var _b;
    var theme = _a.theme;
    return (_b = {},
        _b[".".concat(classes.toolWrapper)] = {
            margin: theme.spacing(1.5, 1, 1.5, 1),
            '&:first-child': {
                marginLeft: 0,
            },
        },
        _b);
});
var ToolRow = function () { return ((0, jsx_runtime_1.jsx)(StyledBox, __assign({ display: "flex", justifyContent: "space-between" }, { children: __spreadArray([], __read(Array(3).keys()), false).map(function (el) { return ((0, jsx_runtime_1.jsx)(material_1.Box, __assign({ display: "flex", flex: "1 0 192px", className: classes.toolWrapper }, { children: (0, jsx_runtime_1.jsx)(Tool_1.default, {}) }), el)); }) }))); };
exports.default = ToolRow;
